


//Swiper Slider
function productSwiper() {
  let swiperContainer = document.querySelector(
    ".custom-product-swiper-container"
  );

  if (!swiperContainer) return;

  let width = window.innerWidth;

  if (width > 1440) {
    swiperContainer.setAttribute("slides-per-view", "4.6");
  } else if (width > 1024) {
    swiperContainer.setAttribute("slides-per-view", "3.6");
  } else if (width > 768) {
    swiperContainer.setAttribute("slides-per-view", "2.6");
  } else if (width > 325) {
    swiperContainer.setAttribute("slides-per-view", "1.6");
  }
}
document.addEventListener("DOMContentLoaded", function () {
  productSwiper();
});

window.addEventListener("resize", function () {
  productSwiper();
});
//Cart Drawer Toggle
// try {
//   let cartOpenBtn = document.querySelector(".cart-open-btn");
//   let cartDrawer = document.querySelector(".custom-cart-drawer");
//   let cartDrawerWrapper = document.querySelector(".custom-cart-container");
//   let cartCloseBtn = document.querySelector(".custom-cart-drawer-top svg");

//   cartOpenBtn.addEventListener("click", () => {
//     if (window.location.href.includes("/cart")) return;
//     cartDrawer.classList.add("cart-drawer-open");
//     cartDrawerWrapper.classList.add("drawer-wrapper-open");
//   });

//   cartCloseBtn.addEventListener("click", () => {
//     cartDrawer.classList.remove("cart-drawer-open");
//     cartDrawerWrapper.classList.remove("drawer-wrapper-open");
//   });

//   cartDrawerWrapper.addEventListener("click", (e) => {
//     if (e.target.closest(".custom-cart-drawer")) return;
//     e.stopPropagation();
//     cartDrawer.classList.remove("cart-drawer-open");
//     cartDrawerWrapper.classList.remove("drawer-wrapper-open");
//   });
// } catch (error) {
//   console.log(error);
// }

//Quantity

  let plusBtn = document.querySelector(".custom-product-qty-plus-btn");
  let minusBtn = document.querySelector(".custom-product-qty-minus-btn");
  let qtyInput = document.querySelector(".product-page-qty");
  // let maxInputValue = qtyInput.getAttribute("data-max");

if (plusBtn && minusBtn && qtyInput) {

  plusBtn.addEventListener("click", () => {
    qtyInput.value = Number(qtyInput.value) + 1;
  });

  minusBtn.addEventListener("click", () => {
    if (qtyInput.value > 1) {
      qtyInput.value = Number(qtyInput.value) - 1;
    }
  });

}

//product card size varient
document.addEventListener("change", function (e) {
  const sizeRadio = e.target.closest(
    ".custom-product-card-size"
  );

  if (!sizeRadio || !sizeRadio.checked) return;

  const card = sizeRadio.closest(".custom-product-card");
  const atcButton = card?.querySelector(
    ".custom-product-card-a-t-c-btn"
  );

  if (!atcButton) return;

  let variants;

  try {
    variants = JSON.parse(
      sizeRadio.dataset.productVariants
    );
  } catch (error) {
    console.error("Unable to parse product variants", error);
    return;
  }

  const optionKey =
    `option${sizeRadio.dataset.sizePosition}`;

  const selectedVariant = variants.find((variant) =>
    variant.available &&
    variant[optionKey] === sizeRadio.value
  );

  atcButton.setAttribute(
    "product-id",
    selectedVariant ? selectedVariant.id : ""
  );
});
document.querySelectorAll(
  ".custom-product-card-size:checked"
).forEach((radio) => {
  radio.dispatchEvent(
    new Event("change", { bubbles: true })
  );
});



//Product ADD TO CART || BUY NOW
try {
  let product = document.querySelector(".custom-product-page-wrapper");
  // let productID = product ? product.getAttribute("product-id") : null;
  let productVariant = product
    ? JSON.parse(product.getAttribute("product-variants"))
    : null;
  let cartBottom = document.querySelector(".custom-cart-drawer-bottom");
  let cartExtra = document.querySelector(".custom-cart-drawer-extra");
  let cartDrawer = document.querySelector(".custom-cart-drawer");
  let cartDrawerWrapper = document.querySelector(".custom-cart-container");
  let buyButton = document.querySelector(".buy-btn");
  
  // let productRemoveBtn = document.querySelector(".custom-cart-item-buttons svg");

  function showNotification(msg) {
    let notificationWrapper = document.querySelector(
      ".custom-notification-wrapper",
    );
    notificationWrapper.style.opacity = "1";
    notificationWrapper.style.pointerEvents = "all";
    notificationWrapper.querySelector("p").textContent = msg;

    setTimeout(() => {
      notificationWrapper.style.opacity = "0";
      notificationWrapper.style.pointerEvents = "none";
    }, 5000);
  }
document.addEventListener('click', (e)=>{   
  let bagIcon = e.target.closest(".custom-product-card-a-t-c-btn svg");  
  if (bagIcon) {
    bagIcon.classList.add('active');

    setTimeout(() => {
      bagIcon.classList.remove('active');
    }, 3000);

  }
})

  async function ADDTOCART(id, qty, button) {
    try {
      let formData;
      // ✅ ONLY for main product
      // console.log(id, id.length);
      if (button.classList.contains("main-product-atc")) {
        let sellingPlan = document.querySelector(
          '[name="selling_plan"]',
        )?.value;

        console.log("Selling Plan:", sellingPlan);

        formData = {
          items: [
            {
              id: id,
              quantity: qty,
              ...(sellingPlan && { selling_plan: sellingPlan }),
            },
          ],
        };
      } else {
        if (id.length > 0) {
          formData = {
            items: id.map((singleId) => ({
              id: singleId,
              quantity: qty,
            })),
          };
        } else {
          formData = {
            items: [{ id: id, quantity: qty }],
          };
        }
      }

      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const data = await response.json();
      if (!response.ok) {
        showNotification(data);
        return false;
      }

      console.log("Added to cart:", data);
let sectionId = button.getAttribute("section-id");

let currUrl = `${window.location.origin}${window.location.pathname}${window.location.search}`;

if (sectionId) {
  currUrl += `#${sectionId}`;
}

localStorage.setItem("continueShoppingUrl", currUrl);

console.log("Saved URL:", currUrl);
      // await updateCartDrawer();
      // Update Cart Count
      const cart = await fetch("/cart.js").then((res) => res.json());
      document.querySelectorAll(".cart-count-span").forEach((span)=> {
        span.textContent = `${cart.item_count}`;
      })
      window.location.href = "/cart";

      showNotification(`Your Item "${data.items[0].title}" is Added To Cart!`);
      return true;
    } catch (err) {
      console.error("Error:", err);
    }
  }

  async function updateCartDrawer() {
    let data = await fetch("/?section_id=custom-cart-drawer");
    let text = await data.text();
    // console.log(text);
    let DIV = document.createElement("DIV");
    DIV.innerHTML = text;
    cartBottom = document.querySelector(".custom-cart-drawer-bottom");
    cartExtra = document.querySelector(".custom-cart-drawer-extra");
    let updatedCartBottom = DIV.querySelector(".custom-cart-drawer-bottom");
    let updatedCartExtra = DIV.querySelector(".custom-cart-drawer-extra");

    if (cartBottom && updatedCartBottom) {
      cartBottom.innerHTML = updatedCartBottom.innerHTML;
    }

    if (cartExtra && updatedCartExtra) {
      cartExtra.innerHTML = updatedCartExtra.innerHTML;
    }

  }

  function cartOpen() {
    cartDrawer.classList.add("cart-drawer-open");
    cartDrawerWrapper.classList.add("drawer-wrapper-open");
  }

  function getVariantID() {
    let radios = document.querySelectorAll(
      ".variant-option input[type='radio']:checked",
    );
    // if (!radios) return;
    let selectedVariant = [];

    radios.forEach((radio) => {
      selectedVariant.push(radio.value);
    });

    console.log(selectedVariant);
    console.log(productVariant);

    if (productVariant.length == 1) {
      console.log(productVariant[0]);
      return productVariant[0];
    } else {
      const matchedVariant = productVariant.find((v) =>
        v.options.every((opt, i) => opt === selectedVariant[i]),
      );
      return matchedVariant;
    }
  }

  document.addEventListener("click", async (e) => {
    let btn = e.target.closest(".a-t-c-btn");
    if (!btn) return;
    let productID = btn ? Number(btn.getAttribute("product-id")) : false;

    // console.log("sdghjkl");
    if (!productID) {
      let variant = getVariantID();
      let variantID = variant ? variant.id : null;
      if (!variantID) return;
      let qty = document.querySelector(".product-page-qty")
        ? Number(document.querySelector(".product-page-qty").value)
        : 1;
      let added = await ADDTOCART(variantID, qty, btn);
      // if (added) cartOpen();
      return;
    }

    let qty = 1;
    let added = await ADDTOCART(productID, qty, btn);
    // if (added) cartOpen();
  });

  document.addEventListener("click", async (e) => {
    let btn = e.target.closest(".buy-btn");
    if (!btn) return;

    let productID = btn ? btn.getAttribute("product-id") : false;
    if (!productID) {
      let variantID = getVariantID().id ? getVariantID().id : null;
      let qty = document.querySelector(".product-page-qty")
        ? Number(document.querySelector(".product-page-qty").value)
        : 1;
      let added = await ADDTOCART(variantID, qty);
      if (added) window.location.href = "/checkout";
    }

    let qty = document.querySelector(".product-page-qty")
      ? Number(document.querySelector(".product-page-qty").value)
      : 1;
    let added = await ADDTOCART(productID, qty);
    if (added) window.location.href = "/checkout";
  });

  document.addEventListener("click", async (e) => {
    let remove_btn = e.target.closest(".custom-cart-item-buttons svg");
    if (!remove_btn) return;
    let product_id = remove_btn.getAttribute("remove-product-id");
    cartBottom.style.opacity = 0.6;

    //Ajax Api Template
    const payload = {
      id: product_id,
      quantity: 0,
    };
    try {
      const response = await fetch(
        `${window.Shopify.routes.root}cart/change.js`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        },
      );
      const result = await response.json();
      console.log("✅ Removed form cart:", result);
      await updateCartDrawer();
      cartBottom.style.opacity = 1;
      return result;
    } catch (error) {
      console.error("❌ Failed to change cart item quantity:", error);
      return null;
    }
  });

  document.addEventListener("DOMContentLoaded", () => {
    const variants = productVariant;
    if (!variants || !variants.length) return;
    let radios = document.querySelectorAll("input[type='radio']");
    const sizeRadios = document.querySelectorAll('input[name="option-1"]');
    const colorRadios = document.querySelectorAll('input[name="option-2"]');

    /* ----------------------------
     1️⃣ Select first available variant
  ---------------------------- */
    const firstAvailable = variants.find((v) => v.available);
    if (!firstAvailable) {
      radios.forEach((r) => {
        r.disabled = true;
        r.closest(".variant-option").classList.add("variant-out-of-stock");
      });

      const atcBtn = document.querySelectorAll(
        ".custom-product-qty-n-btn-wrapper .a-t-c-btn",
      );
      const buyBtn = document.querySelectorAll(
        ".custom-product-button-wrapper .buy-btn",
      );
      const qtyInput = document.querySelectorAll(
        ".custom-product-qty-n-btn-wrapper .custom-product-qty",
      );

      if (atcBtn) {
        atcBtn.forEach((btn) => {
          btn.textContent = "Out Of Stock";
          btn.classList.add("addtocart-class");
        });
      }

      if (buyBtn) {
        buyBtn.forEach((btn) => {
          btn.style.display = "none";
        });
      }

      if (qtyInput) {
        qtyInput.forEach((input) => {
          input.style.display = "none";
        });
      }
    }

    const selectRadio = (name, value) => {
      const r = document.querySelector(
        `input[name="${name}"][value="${value}"]`,
      );
      if (r) r.checked = true;
    };

    selectRadio("option-1", firstAvailable.options[0]);
    selectRadio("option-2", firstAvailable.options[1]);

    /* ----------------------------
     2️⃣ Update SIZE availability
  ---------------------------- */
    const updateSizes = () => {
      sizeRadios.forEach((sizeRadio) => {
        const sizeValue = sizeRadio.value;

        const hasAnyAvailable = variants.some(
          (v) => v.available && v.options[0] === sizeValue,
        );

        sizeRadio.disabled = !hasAnyAvailable;
        sizeRadio
          .closest(".variant-option")
          ?.classList.toggle("variant-out-of-stock", !hasAnyAvailable);
      });
    };

    /* ----------------------------
     3️⃣ Update COLOR availability
  ---------------------------- */
    const updateColors = () => {
      const selectedSize = document.querySelector(
        'input[name="option-1"]:checked',
      )?.value;

      if (!selectedSize) return;

      colorRadios.forEach((colorRadio) => {
        const colorValue = colorRadio.value;

        const isAvailable = variants.some(
          (v) =>
            v.available &&
            v.options[0] === selectedSize &&
            v.options[1] === colorValue,
        );

        colorRadio.disabled = !isAvailable;
        colorRadio
          .closest(".variant-option")
          ?.classList.toggle("variant-out-of-stock", !isAvailable);
      });

      // Auto-select first available color
      const checkedColor = document.querySelector(
        'input[name="option-2"]:checked',
      );
      if (!checkedColor || checkedColor.disabled) {
        const firstAvailableColor = Array.from(colorRadios).find(
          (r) => !r.disabled,
        );
        if (firstAvailableColor) firstAvailableColor.checked = true;
      }
    };

    /* ----------------------------
     4️⃣ Init
  ---------------------------- */
    updateSizes();
    updateColors();

    /* ----------------------------
     5️⃣ Events
  ---------------------------- */
    sizeRadios.forEach((radio) => {
      radio.addEventListener("change", () => {
        updateColors();
      });
    });
  });
  

  // Auto Select Variant
  function autoSelectVariant() {
    document.addEventListener("DOMContentLoaded", () => {
      const params = new URLSearchParams(window.location.search);
      const variantId = params.get("variant");
      if (variantId) {
        const selectedVariant = productVariant.find((v) => v.id == variantId);
        // console.log(selectedVariant);

        if (selectedVariant.available) {
          let inputRadio = document.querySelector(
            `input[type='radio'][value='${selectedVariant.title}']`,
          );
          if (inputRadio) {
            setTimeout(() => {
              inputRadio.checked = true;
            }, 1000);

            return;
          }
        }
        // console.log(inputRadio);
      }
    });
  }
  autoSelectVariant();
} catch (error) {
  console.log(error);
}

// Price Change || Variant Image
let product = document.querySelector(".custom-product-page-wrapper");
if(product) {

    let variantRadios = document.querySelectorAll(
      ".variant-option input[type='radio']",
    );
    let product = document.querySelector(".custom-product-page-wrapper");
    // let productID = product ? product.getAttribute("product-id") : null;
    let productVariant = product
      ? JSON.parse(product.getAttribute("product-variants"))
      : null;
    let productPrice = document.querySelector(".product-page-price");
    let productComparePrice = document.querySelector(
      ".product-page-compare-price",
    );

// Cache every slide once, before any filtering happens
function getAllSlides(swiperEl) {
  if (!window.__allSlidesCache) {
    window.__allSlidesCache = Array.from(
      swiperEl.querySelectorAll("swiper-slide[media-alt]")
    ).map((slide) => {
      const clone = slide.cloneNode(true);
      clone.style.display = ""; // drop any desktop display:none
      return clone;
    });
  }
  return window.__allSlidesCache;
}

function updateVariantImages(retries = 20) {
  const selectedColor = document.querySelector('input[name="option-2"]:checked')?.value;
  if (!selectedColor) return;

  const color = selectedColor.trim().toLowerCase();
  const swiperEl = document.querySelector(".custom-product-page-swiper-container");
  if (!swiperEl) return;

  const matches = (slide) =>
    (slide.getAttribute("media-alt") || "").trim().toLowerCase() === color;

  const isMobile = window.matchMedia("(max-width: 768px)").matches;

  // Always cache first, while all slides are still in the DOM
  const allSlides = getAllSlides(swiperEl);

  // 1. Single-color product: nothing to filter
  if (document.querySelectorAll('input[name="option-2"]').length < 2) return;

  // 2. No slide is tagged with this color: don't hide everything
  if (!allSlides.some(matches)) return;

  // DESKTOP
  if (!isMobile) {
    swiperEl.querySelectorAll("swiper-slide[media-alt]").forEach((slide) => {
      slide.style.display = matches(slide) ? "" : "none";
    });
    return;
  }

  // MOBILE
  const swiper = swiperEl.swiper;
  if (!swiper) {
    if (retries > 0) setTimeout(() => updateVariantImages(retries - 1), 100);
    return;
  }

  // Build from the cache, not from the live DOM
  const matching = allSlides.filter(matches).map((s) => s.cloneNode(true));

  swiper.removeAllSlides();
  swiper.appendSlide(matching);
  swiper.update();
  swiper.slideTo(0, 0);
  window.bindProductZoom?.();
}

  // Cover every load order
  window.addEventListener("productSwiperReady", () => updateVariantImages());
  if (window.__productSwiperReady) updateVariantImages();
  window.addEventListener("load", () => updateVariantImages());

  variantRadios.forEach((radio) => {
    radio.addEventListener("change", () => {
      updatePrice();
      updateVariantImages();
    });
  });


// // Cache every slide once, before any filtering happens
// function getAllSlides(swiperEl) {
//   if (!window.__allSlidesCache) {
//     window.__allSlidesCache = Array.from(
//       swiperEl.querySelectorAll("swiper-slide")
//     ).map((slide) => {
//       const clone = slide.cloneNode(true);
//       clone.style.display = "";
//       return clone;
//     });
//   }
//   return window.__allSlidesCache;
// }

// function updateVariantImages(retries = 20) {
//   const swiperEl = document.querySelector(".custom-product-page-swiper-container");
//   if (!swiperEl) return;

//   const allSlides = getAllSlides(swiperEl);

//   const colorRadios = document.querySelectorAll('input[name="option-2"]');
//   const selectedColor = document
//     .querySelector('input[name="option-2"]:checked')
//     ?.value?.trim()
//     .toLowerCase();

//   const altOf = (slide) =>
//     (slide.getAttribute("media-alt") || "").trim().toLowerCase();

//   // Only filter if there are multiple colors AND at least one slide is tagged with the selected color
//   const shouldFilter =
//     colorRadios.length > 1 &&
//     selectedColor &&
//     allSlides.some((s) => altOf(s) === selectedColor);

//   // Untagged slides always show; tagged ones must match
//   const matches = (slide) => {
//     if (!shouldFilter) return true;
//     const alt = altOf(slide);
//     return !alt || alt === selectedColor;
//   };

//   const isMobile = window.matchMedia("(max-width: 768px)").matches;

//   // DESKTOP
//   if (!isMobile) {
//     swiperEl.querySelectorAll("swiper-slide").forEach((slide) => {
//       slide.style.display = matches(slide) ? "" : "none";
//     });
//     return;
//   }

//   // MOBILE
//   const swiper = swiperEl.swiper;
//   if (!swiper) {
//     if (retries > 0) setTimeout(() => updateVariantImages(retries - 1), 100);
//     return;
//   }

//   const matching = allSlides.filter(matches).map((s) => s.cloneNode(true));
//   if (!matching.length) return; // never leave the gallery empty

//   swiper.removeAllSlides();
//   swiper.appendSlide(matching);
//   swiper.update();
//   swiper.slideTo(0, 0);
//   window.bindProductZoom?.();
// }


    function updatePrice() {
      try {
        let slsProductPrice = document
          .querySelector("[data-one-time-option-radio]")
          ?.parentElement?.querySelector(".seal-money");
        // console.log(slsProductPrice);
        let slsProductComparePrice = document
          .querySelector("[data-selling-plan-group-option-radio]")
          ?.parentElement?.querySelector(".sls-price");

        // console.log(slsProductComparePrice, slsProductPrice);

        let selectedRadiosArr = [];
        let selectedRadios = document.querySelectorAll(
          ".variant-option input[type='radio']:checked",
        );
        selectedRadios.forEach((radio) => {
          selectedRadiosArr.push(radio.value);
        });
        // console.log(selectedRadiosArr);

        const matchedVariant = productVariant.find((v) =>
          v.options.every((opt, i) => opt === selectedRadiosArr[i]),
        );

        // console.log(matchedVariant);
        if (!matchedVariant) return;
        let newPrice = matchedVariant.price / 100;
        let newComparePrice = matchedVariant.compare_at_price / 100;

        const price = newPrice;
        const discount = 10;

        const finalPrice = price - (price * discount) / 100;

        // console.log(finalPrice);

        if (productPrice) {
          productPrice.innerHTML = `${newPrice.toFixed(2)} ${product.getAttribute(
            "shop-curreny",
          )}`;
        }

        // if (slsProductPrice) {
        //   slsProductPrice.innerHTML = `${product.getAttribute(
        //     "shop-curreny",
        //   )} ${newPrice.toFixed(2)}`;
        // }

        if (productComparePrice) {
          if (newComparePrice > newPrice) {
            productComparePrice.classList.remove("compare-price-hide");
            productComparePrice.innerHTML = `${newComparePrice.toFixed(
              2,
            )} ${product.getAttribute("shop-curreny")}`;
          } else {
            productComparePrice.innerHTML = ``;
          }
        }

        // if (slsProductComparePrice) {
        //   // if (newComparePrice > newPrice) {
        //   slsProductComparePrice.classList.remove("compare-price-hide");
        //   slsProductComparePrice.innerHTML = `
        //       <span>${product.getAttribute("shop-curreny")} ${finalPrice.toFixed(2)}</span>
        //       <span style="text-decoration:line-through; text-decoration-color: grey; color: grey; padding-left: 4px;">${product.getAttribute("shop-curreny")} ${newPrice.toFixed(2)}</span>
        //     `;
        //   // } else {
        //   //   slsProductComparePrice.innerHTML = ``;
        //   // }
        // }
      } catch (error) {
        console.log(error);
      }

    }

    // function updateVariant() {
    //   let selectedOptions = [];

    //   document
    //     .querySelectorAll(".variant-option input[type='radio']:checked")
    //     .forEach((select) => {
    //       selectedOptions.push(select.value);
    //     });

    //   let matchedVariant = productVariant.find((v) =>
    //     selectedOptions.every((opt, i) => v[`option${i + 1}`] === opt),
    //   );

    //   if (!matchedVariant || !matchedVariant.featured_media) return;

    //   let targetedMediaID = matchedVariant.featured_media.id;

    //   let swiperEl = document.querySelector(
    //     ".custom-product-page-swiper-container",
    //   );
    //   if (!swiperEl || !swiperEl.swiper) return;

    //   let targetedSlide = swiperEl.querySelector(
    //     `swiper-slide[data-media-id="${targetedMediaID}"]`,
    //   );

    //   if (!targetedSlide) return;

    //   let index = [...swiperEl.swiper.slides].indexOf(targetedSlide);

    //   swiperEl.swiper.slideToLoop
    //     ? swiperEl.swiper.slideToLoop(index)
    //     : swiperEl.swiper.slideTo(index);
    // }

}


//Search Drawer (toggle) || Search Drawer Results
try {
  let searchDrawerContainer = document.querySelector(
    ".custom-search-drawer-container ",
  );
  let searchDrawerWrapper = document.querySelector(
    ".custom-search-drawer-wrapper",
  );
  let searchDrawerResultsWrapper = document.querySelector(
    ".custom-search-drawer-results-wrapper",
  );
  let searchDrawerOpenBtn = document.querySelector("#custom-search-open");
  let searchDrawerCloseBtn = document.querySelector(
    ".custom-search-drawer-close-btn svg",
  );
  let searchInputClearBtn = document.querySelector(
    ".custom-search-bar-clear-btn",
  );
  let searchIcon = document.querySelector(".custom-search-bar-icon");

  searchDrawerOpenBtn.addEventListener("click", () => {
    searchDrawerContainer.classList.add("search-drawer-class");
    searchDrawerWrapper.classList.add("search-drawer-wrapper-class");
  });

  searchDrawerCloseBtn.addEventListener("click", () => {
    searchDrawerContainer.classList.remove("search-drawer-class");
    searchDrawerWrapper.classList.remove("search-drawer-wrapper-class");
  });

  searchDrawerContainer.addEventListener("click", (e) => {
    if (e.target.closest(".custom-search-drawer-wrapper")) return;
    if (e.target.closest(".custom-search-drawer-results-wrapper")) return;
    e.stopPropagation();
    searchDrawerContainer.classList.remove("search-drawer-class");
    searchDrawerWrapper.classList.remove("search-drawer-wrapper-class");
  });

  //Search Drawer Results
  let searchInput = document.querySelector(".custom-search-bar");

  async function getSearchResults(query) {
    let res = await fetch(
      `/search/suggest.json?q=${query}&resources[type]=query,product,page,article&resources[limit]=10`,
    );
    let data = await res.json();
    console.log(data);

    let products = data.resources.results.products.slice(0, 5);
    let pages = data.resources.results.pages.slice(0, 1);
    let articles = data.resources.results.articles.slice(0, 2);
    let suggestQueries = data.resources.results.queries.slice(0, 5);

    if (products.length == 0) {
      searchDrawerResultsWrapper.innerHTML = `
    <a href="/search?q=${query}">
      <div class="empty-result-container">
      <p class="go-to-search">Click to get Results for "${query}"</p>
    </div>
    </a>
    `;
      return;
    } else {
      searchDrawerResultsWrapper.innerHTML = `
       <div class="custom-search-drawer-sug-page-wrapper">
      <div class="custom-search-drawer-result-suggestions-wrapper">
        <p>Suggestions</p>
        <div class="custom-search-drawer-result-suggestions"></div>
      </div>
      <div class="custom-search-drawer-result-page-wrapper">
        <p>Pages & Articles</p>
        <div class="custom-search-drawer-result-pages"></div>
      </div>
    </div>
    <div class="custom-search-drawer-results-items-wrapper"></div>
    `;
    }

    await updateProduct(products);
    await updatePageArticle(pages, articles);
    await updateSuggestion(suggestQueries);
    // await checkResults(products, pages, articles, suggestQueries);
    searchDrawerResultsWrapper.classList.add("search-drawer-class");

    if (searchDrawerResultsWrapper.classList.contains("search-drawer-class")) {
      searchInputClearBtn.classList.add("custom-search-bar-clear-btn-class");
    } else {
      searchInputClearBtn.classList.remove("custom-search-bar-clear-btn-class");
    }
  }

  async function updateProduct(products) {
    let searchDrawerResultsItemWrapper = document.querySelector(
      ".custom-search-drawer-results-items-wrapper",
    );

    const countryCode = document
      .querySelector(".custom-search-drawer-container")
      .getAttribute("countryCode");

    let resultProduct = ``;
    products.forEach((product) => {
      let showProduct = true;

      // For AE: hide KSA products
      if (countryCode === "AE" && product.handle.includes("ksa")) {
        showProduct = false;
      }

      // For SA: only show KSA products
      if (countryCode === "SA" && !product.handle.includes("ksa")) {
        showProduct = false;
      }

      if (!showProduct) return;

      console.log(product);

      resultProduct += `
      <a href="${product.url}">
        <div class="custom-search-drawer-result-item">
          <div class="custom-search-drawer-result-item-img">
            <img src="${product.featured_image.url}" alt="" loading="lazy">
          </div>
          <div class="custom-search-drawer-result-item-txt-cnt">
            <div class="search-item-title">${product.title}</div>
            <div class="search-item-price">
              <span>
                <span class="money currency-price" data-aed-price="${product.price_min}"> ${product.price_min} ${Shopify.currency.active} </span>
                -
                <span class="money currency-price" data-aed-price="${product.price_max}"> ${product.price_max} ${Shopify.currency.active} </span>
              </span>
            </div>
          </div>
        </div>
      </a>
    `;
    });
    if (searchDrawerResultsItemWrapper) {
      searchDrawerResultsItemWrapper.innerHTML = resultProduct;
      //   const savedCurrency = localStorage.getItem("selectedCurrency") || "AED";
      //   updatePrices(savedCurrency);
    }
  }

  async function updatePageArticle(pages, articles) {
    let resultPageWrapper = document.querySelector(
      ".custom-search-drawer-result-pages",
    );

    // let pages = data.resources.results.pages;
    // let articles = data.resources.results.articles;

    if (pages.length == 0 && articles.length == 0) {
      resultPageWrapper.parentElement.classList.add("display-none-class");
    } else {
      let newPage = ``;
      let newArticle = ``;

      articles.forEach((article) => {
        newArticle += `
      <a href="${article.url}">${article.title}</a>
    `;
      });
      if (resultPageWrapper) {
        resultPageWrapper.innerHTML = newArticle;
      }
      pages.forEach((page) => {
        newPage += `
      <a href="${page.url}">${page.title}</a>
    `;
      });
      if (resultPageWrapper) {
        resultPageWrapper.innerHTML += newPage;
      }
    }
  }

  async function updateSuggestion(suggestQueries) {
    let suggestionWrapper = document.querySelector(
      ".custom-search-drawer-result-suggestions",
    );

    if (suggestQueries.length == 0) {
      suggestionWrapper.parentElement.classList.add("display-none-class");
    } else {
      let queryItem = ``;
      suggestQueries.forEach((queries) => {
        queryItem += `
      <a href="${queries.url}">${queries.text}</a>
    `;
      });
      if (suggestionWrapper) {
        suggestionWrapper.innerHTML = queryItem;
      }
    }
  }

  searchInputClearBtn.addEventListener("click", () => {
    searchDrawerResultsWrapper.classList.remove("search-drawer-class");
    searchInput.value = "";
    searchInputClearBtn.classList.remove("custom-search-bar-clear-btn-class");
  });

  let debounceTimer;
  searchInput.addEventListener("input", () => {
    let searchQuery = searchInput.value.trim();
    if (!searchQuery) return;

    searchIcon.querySelector("svg").style.display = "none";
    searchIcon.classList.add("search-icon-class");

    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(async () => {
      try {
        await getSearchResults(searchQuery);
      } catch (err) {
        console.error(err);
      } finally {
        searchIcon.querySelector("svg").style.display = "block";
        searchIcon.classList.remove("search-icon-class");
      }
    }, 500);
  });

  searchIcon.addEventListener("click", () => {
    let query = searchInput.value;
    if (!query) return;
    window.location.href = `/search?q=${query}`;
  });
} catch (error) {
  console.log(error);
}
/* =========================
   CUSTOM WISHLIST
========================= */

(function () {

  'use strict';

  const STORAGE_KEY = 'custom-wishlist';


  function getWishlist() {

    try {

      return JSON.parse(
        localStorage.getItem(STORAGE_KEY)
      ) || [];

    } catch (error) {

      console.error('Wishlist error:', error);

      return [];

    }

  }


  function saveWishlist(wishlist) {

    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify(wishlist)
    );

  }


  function isWishlisted(handle) {

    return getWishlist().includes(handle);

  }


  function updateWishlistButtons() {

    const buttons =
      document.querySelectorAll(
        '[data-wishlist-button]'
      );

    const wishlist = getWishlist();


    buttons.forEach(function (button) {

      const handle =
        button.dataset.productHandle;

      if (!handle) return;


      if (wishlist.includes(handle)) {

        button.classList.add('is-wishlisted');

        button.setAttribute(
          'aria-label',
          'Remove from wishlist'
        );

        button.setAttribute(
          'aria-pressed',
          'true'
        );

      } else {

        button.classList.remove('is-wishlisted');

        button.setAttribute(
          'aria-label',
          'Add to wishlist'
        );

        button.setAttribute(
          'aria-pressed',
          'false'
        );

      }

    });

  }


  function toggleWishlist(handle) {

    let wishlist = getWishlist();


    if (wishlist.includes(handle)) {

      wishlist = wishlist.filter(
        function (item) {
          return item !== handle;
        }
      );

    } else {

      wishlist.push(handle);

    }


    saveWishlist(wishlist);

    updateWishlistButtons();


    window.dispatchEvent(
      new CustomEvent('wishlist:updated', {
        detail: {
          handle: handle,
          wishlisted: wishlist.includes(handle)
        }
      })
    );

  }


  document.addEventListener(
    'click',
    function (event) {

      const button =
        event.target.closest(
          '[data-wishlist-button]'
        );


      if (!button) return;


      event.preventDefault();

      event.stopPropagation();


      const handle =
        button.dataset.productHandle;


      if (!handle) return;


      toggleWishlist(handle);

    }
  );


  window.CustomWishlist = {

    getWishlist: getWishlist,

    saveWishlist: saveWishlist,

    isWishlisted: isWishlisted,

    toggleWishlist: toggleWishlist,

    updateButtons: updateWishlistButtons

  };


  function initializeWishlist() {

    updateWishlistButtons();

    window.dispatchEvent(
      new CustomEvent('wishlist:ready')
    );

  }


  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initializeWishlist
    );

  } else {

    initializeWishlist();

  }

})();



// Redirect logic
let redirectBtn = document.querySelector(".custom-redirect");

if (redirectBtn) {
  const currUrl = localStorage.getItem("continueShoppingUrl");

  if (currUrl) {
    redirectBtn.href = currUrl === "" ? "/all" : currUrl;
    redirectBtn.addEventListener("click", () => {
      localStorage.removeItem("continueShoppingUrl");
    });
  }
}

// ========================================
// PRODUCT PAGE IMAGE ZOOM
// ========================================

const boundPictures = new WeakSet(); // WeakSet, NOT a data-attribute: cloneNode copies attributes

const isMobileView = () => window.matchMedia('(max-width: 768px)').matches;

// ---------- GLOBAL SETUP (runs once) ----------
const lightbox = document.querySelector('.custom-product-image-lightbox');
const lightboxContent = document.querySelector('.custom-product-image-lightbox-content');
const lightboxImage = document.querySelector('.custom-product-image-lightbox-image');
const lightboxClose = document.querySelector('.custom-product-image-lightbox-close');
let lightboxOpen = false;

function openLightbox(image) {
  if (!lightbox || !lightboxImage) return;
  if (lightbox.parentElement !== document.body) document.body.appendChild(lightbox);

  lightboxImage.src = image.currentSrc || image.src;
  lightboxImage.alt = image.alt || '';
  lightboxImage.style.transform = 'scale(1)';
  lightboxImage.style.transformOrigin = 'center center';

  lightbox.classList.add('active');
  lightbox.setAttribute('aria-hidden', 'false');
  lightboxOpen = true;
  document.body.classList.add('product-lightbox-open');
}

function closeLightbox() {
  if (!lightbox || !lightboxImage) return;
  lightbox.classList.remove('active');
  lightbox.setAttribute('aria-hidden', 'true');
  lightboxImage.style.transform = 'scale(1)';
  lightboxImage.style.transformOrigin = 'center center';
  lightboxOpen = false;
  document.body.classList.remove('product-lightbox-open');
}

function initLightboxOnce() {
  if (lightboxClose) {
    lightboxClose.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      closeLightbox();
    });
  }

  if (lightbox) {
    lightbox.addEventListener('click', (e) => {
      if (e.target === lightbox) closeLightbox();
    });
  }

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && lightboxOpen) closeLightbox();
  });

  if (lightboxContent && lightboxImage) {
    lightboxContent.addEventListener('mousemove', (e) => {
      if (!lightboxOpen) return;
      const rect = lightboxContent.getBoundingClientRect();
      const xPercent = ((e.clientX - rect.left) / rect.width) * 100;
      const yPercent = ((e.clientY - rect.top) / rect.height) * 100;
      lightboxImage.style.transformOrigin = `${xPercent}% ${yPercent}%`;
      lightboxImage.style.transform = 'scale(2)';
    });

    lightboxContent.addEventListener('mouseleave', () => {
      if (!lightboxOpen) return;
      lightboxImage.style.transform = 'scale(1)';
      lightboxImage.style.transformOrigin = 'center center';
    });
  }
}

// ---------- PER-PICTURE BINDING (safe to call repeatedly) ----------
function bindPictures() {
  const pictures = document.querySelectorAll(
    '.custom-product-page-swiper-container swiper-slide picture'
  );

  pictures.forEach((picture) => {
    if (boundPictures.has(picture)) return; // already bound
    const image = picture.querySelector('img');
    if (!image) return;
    boundPictures.add(picture);

    // Desktop lightbox
    picture.addEventListener('click', () => {
      if (isMobileView()) return;
      openLightbox(image);
    });

    // Mobile zoom
    const zoomButton = picture.querySelector('.custom-product-image-zoom-button');
    if (!zoomButton) return;

    let isZoomed = false;
    let startX = 0, startY = 0;
    let startOriginX = 50, startOriginY = 50;
    let lastTapTime = 0;

    function toggleMobileZoom() {
      isZoomed = !isZoomed;
      picture.classList.toggle('mobile-zoom-active', isZoomed);
      image.style.transform = isZoomed ? 'scale(2)' : 'scale(1)';
      image.style.transformOrigin = '50% 50%';
    }

    zoomButton.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      toggleMobileZoom();
    });

    // Double tap
    picture.addEventListener('touchend', (e) => {
      if (!isMobileView()) return;
      const now = Date.now();
      const tapLength = now - lastTapTime;
      if (tapLength < 300 && tapLength > 0) {
        e.preventDefault();
        e.stopPropagation();
        toggleMobileZoom();
        lastTapTime = 0;
      } else {
        lastTapTime = now;
      }
    }, { passive: false });

    // Pan while zoomed
    picture.addEventListener('touchstart', (e) => {
      if (!isZoomed) return;
      const touch = e.touches[0];
      startX = touch.clientX;
      startY = touch.clientY;
      const origin = image.style.transformOrigin.replace(/%/g, '').split(' ');
      startOriginX = parseFloat(origin[0]) || 50;
      startOriginY = parseFloat(origin[1]) || 50;
    }, { passive: false });

    picture.addEventListener('touchmove', (e) => {
      if (!isZoomed) return;
      e.preventDefault();
      e.stopPropagation();
      const touch = e.touches[0];
      const rect = picture.getBoundingClientRect();
      const newX = startOriginX - (touch.clientX - startX) * (100 / rect.width);
      const newY = startOriginY - (touch.clientY - startY) * (100 / rect.height);
      image.style.transformOrigin =
        `${Math.max(0, Math.min(100, newX))}% ${Math.max(0, Math.min(100, newY))}%`;
    }, { passive: false });
  });
}

// Expose so other scripts can re-bind after slides change
window.bindProductZoom = bindPictures;

// ---------- INIT ----------
function initProductImageZoom() {
  initLightboxOnce();
  bindPictures();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initProductImageZoom);
} else {
  initProductImageZoom();
}